import {z} from 'zod';

import {convertDbSizeToBytes} from '../../functions/convertDbSizeToBytes';
import {ImageDepth, ImageType} from '../../types/enums';

import {geolocationWithAltitudeSchema} from './geolocation';
import {slimUserSchema} from './slimUserSchema';

export const imageListSchema = z
  .object({
    id: z.string().min(1),
    name: z.string().min(1),
    type: z.enum(ImageType),
    depth: z.enum(ImageDepth),
    location: geolocationWithAltitudeSchema.nullable(),
    captureDate: z.coerce.date().nullable(),
    createdBy: slimUserSchema.nullable(),
    modified: z.coerce.date(),
    dimensions: z.tuple([z.number().nonnegative(), z.number().nonnegative()]),
    isFlagged: z.boolean(),
    size: z
      .number()
      .nonnegative()
      .transform((n) => convertDbSizeToBytes(n, 'file')),

    counts: z.object({
      annotations: z.number().nonnegative(),
      measurement2s: z.number().nonnegative(),
    }),

    paths: z.object({
      tiles: z.string(),
      thumbnail: z.string(),
      temperatures: z.string().nullable(),
    }),
  })
  .array();
